import 'fg-frontend/third/highslide/highslide-full';

const hs = window.hs;

hs.graphicsDir = '/img/highslide/';
hs.transitions = ['expand', 'crossfade'];
hs.objectLoadTime = 'before'; // Load iframes 'before' or 'after' expansion.
hs.outlineType = null;
hs.align = 'center';
hs.dimmingOpacity = 0.9;

hs.cacheAjax = false;
hs.preserveContent = false;

// credits off
hs.showCredits = false;
hs.creditsHref = '';
hs.lang.creditsText = '';
hs.lang.creditsTitle = '';
hs.captionEval = '';

if (hs.registerOverlay) {
  hs.registerOverlay({
    fade: 2,
    hideOnMouseOut: false,
    html: '<a href="javascript:" onclick="return hs.close(this)" class="closebutton">Zavřít</a>',
    useOnHtml: true,
    position: 'top right'
  });
}


hs.Expander.prototype.onBeforeExpand = (sender) => {
  // jen pro obrazky
  if (sender.a.className.indexOf('hs-htmlExpand') < 0) {
    // dynamicka navigace mezi fotkami
    const arrowLeft = document.createElement('div');
    const arrowRight = document.createElement('div');

    if (sender.getAdjacentAnchor(-1)) {
      arrowLeft.innerHTML = '<a href="javascript:" onclick="return hs.previous(this)" title="Předchozí" class="highslide-previous"><span class="glyphicon glyphicon-arrow"></span></a>';
      arrowLeft.className = 'controlbar-arrows';
    }
    if (sender.getAdjacentAnchor(1)) {
      arrowRight.innerHTML = '<a href="javascript:" onclick="return hs.next(this)" title="Následující" class="highslide-next"><span class="glyphicon glyphicon-arrow"></span></a>';
      arrowRight.className = 'controlbar-arrows';
    }
    if (arrowLeft.innerHTML !== '') {
      sender.createOverlay({
        overlayId: arrowLeft,
        position: 'middle left',
        hideOnMouseOut: false,
        opacity: 1,
        width: 'auto',
        fade: 2,
      });
    }
    if (arrowRight.innerHTML !== '') {
      sender.createOverlay({
        overlayId: arrowRight,
        position: 'middle right',
        hideOnMouseOut: false,
        opacity: 1,
        width: 'auto',
        fade: 2,
      });
    }
  }
};

hs.Expander.prototype.onAfterExpand = function(sender) {
    $("body").css("overflow-y","hidden");
    // $("nav.navbar").hide();
};

hs.Expander.prototype.onAfterClose = function (sender) {
    $("body").css("overflow-y","visible");
    // $("nav.navbar").show();
};

export default hs;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/hsExpand/highslide-settings.js